<style lang="less">
.daUserGroup {
  &--pin {
    width: 1.2rem;
    height: 1.2rem;
    position: relative;
    left: 0;
    top: 0;
    .daUserItem {
      position: absolute;
      &--0 {
        top: 0;
        left: 50%;
        margin-left: -0.32rem;
      }
      &--1 {
        bottom: 0;
        left: 0;
      }
      &--2 {
        bottom: 0;
        right: 0;
      }
    }
  }
  &--x3 {
    text-align: center;
    padding:.2rem 0;
    .daUserItem {
      display: inline-block;
    }
    .daUserItem + .daUserItem {
      margin-left: .5rem;
    }
  }
}
</style>
<template>
  <div class="daUserGroup">
    <da-user-item class="daUserItem--0" :item="items[0]" />
    <da-user-item class="daUserItem--1" :item="items[1]" />
    <da-user-item class="daUserItem--2" :item="items[2]" />
  </div>
</template>
<script>
import daUserItem from './da-user-item'
export default {
  components: {
    daUserItem
  },
  props: ['group'],
  computed: {
    items() {
      return this.group || []
    }
  }
}
</script>
